import { UserContext } from "context/User/UserContext";
import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router";
import Loading from "./Loading";
import { useAppConfig } from "context/ConfigContext";

export function ProtectedRoute({ access }) {
  const appConfig = useAppConfig();
  const { user: userMeta, loading } = useContext(UserContext);

  if (loading === true) {
    return <Loading />;
  }

  if (userMeta === null || userMeta.isLoggedIn === false) {
    window.location.href = appConfig.COGNITO_HOSTED_UI_LOGIN;
    return <Loading />;
  }

  if (userMeta.isLoggedIn === null) {
    return <Loading />;
  }

  if (access !== null && userMeta.role !== access) {
    return <Navigate to="/notfound" replace />;
  }

  return <Outlet />;
}
